import { render } from "./configuracion.vue?vue&type=template&id=c05de8f2&scoped=true"
import script from "./configuracion.vue?vue&type=script&lang=js"
export * from "./configuracion.vue?vue&type=script&lang=js"

import "./configuracion.vue?vue&type=style&index=0&id=c05de8f2&lang=scss&scoped=true"
import "./configuracion.vue?vue&type=style&index=1&id=c05de8f2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c05de8f2"]])

export default __exports__